// Notepad helpers (2026-10-04): the tag a note carries and the prompt that sends the open notes to Claude Code.
// Pure functions, tested by frontend/tests/errorHunter.test.mjs. Persistence is server side (/api/notes, shared/gui_notes.py).
import { resolveLink } from './alertGroups.js'

const MAX_PROMPT = 4800   // the deep link allows 5,000 characters of prompt; leave room for the header lines

export function relTag(n) {
  const v = n.version ? String(n.version).toUpperCase() : ''
  const p = n.page || ''
  return v || p ? `[${[v, p].filter(Boolean).join(' ')}]` : '[no tag]'
}

const HEAD =
  'Notes from using the dashboard versions (ORIG, V1 to V4). Each note is tagged with the version and page it was written on. ' +
  'Work out the change each one asks for, group duplicates, and propose the edits (apply the clearly safe ones, ask about the rest):\n\n'

// The open (not done) notes as a prompt asking Claude to apply the changes, oldest first. When they do not all fit, the
// NEWEST are kept (they are the ones still being worked on), cut at a note boundary, and the prompt says how many older
// ones were left out, so nothing is silently dropped. `notes` arrive newest first, as /api/notes returns them.
export function notesPrompt(notes) {
  const newestFirst = (notes || []).filter(n => !n.done)
  if (newestFirst.length === 0) return ''
  const lines = []
  let size = HEAD.length + 120   // room for the "older notes left out" line
  for (const n of newestFirst) {
    const line = `- ${relTag(n)} ${String(n.body).replace(/\s+/g, ' ').trim()}\n`
    if (size + line.length > MAX_PROMPT) break
    lines.push(line)
    size += line.length
  }
  let out = HEAD + lines.reverse().join('')
  const left = newestFirst.length - lines.length
  if (left > 0) out += `\n(${left} older open note${left === 1 ? '' : 's'} did not fit; read the gui_notes table for them.)\n`
  return out.slice(0, 5000)
}

export const notesLink = (notes) => {
  const p = notesPrompt(notes)
  return p ? resolveLink(p) : null
}
